import { useTimeline, type SpeedFactor } from '../store/timelineStore';

function jdToIso(jd: number): string {
  const ms = (jd - 2440587.5) * 86400 * 1000;
  return new Date(ms).toISOString().slice(0, 10);
}

const SPEEDS: SpeedFactor[] = [1, 10, 100, 1000, 10000];

export default function Timeline() {
  const { tJd, startJd, stopJd, speed, playing, set, setSpeed, togglePlay, reset } =
    useTimeline();

  return (
    <div className="timeline">
      <button onClick={togglePlay}>{playing ? 'Pause' : 'Play'}</button>
      <button onClick={() => set(Math.max(startJd, tJd - speed))}>⟨⟨</button>
      <button onClick={() => set(Math.min(stopJd, tJd + speed))}>⟩⟩</button>
      <input
        type="range"
        min={startJd}
        max={stopJd}
        step={1}
        value={tJd}
        onChange={(e) => set(Number(e.target.value))}
      />
      <span className="date">{jdToIso(tJd)}</span>
      <select
        value={speed}
        onChange={(e) => setSpeed(Number(e.target.value) as SpeedFactor)}
      >
        {SPEEDS.map((s) => (
          <option key={s} value={s}>
            ×{s.toLocaleString('fr-FR')}
          </option>
        ))}
      </select>
      <button onClick={reset}>Reset</button>
    </div>
  );
}
